// ADR 23.9.26v §3/§4 — the app's query client.
//
// `gcTime` follows `maxAge` for every persisted prefix: a query leaves the
// persisted blob when it leaves the in-memory cache, and the default five
// minutes would lose a plan read ten minutes before take-off.
//
// `networkMode` stays the default `'online'`, deliberately: `offlineFirst` is
// for a `queryFn` a service worker can answer, and roadmap D2 forbids that
// cache. With `onlineManager` told the truth, an offline restored query shows
// its data `paused`, an unrestored one stays `pending` rather than erroring, and
// `refetchOnReconnect` refreshes both.
//
// Suites use `testQueryClient()` instead, so none of this — the online signal
// included — is active in a suite that does not opt in.

import { QueryClient } from '@tanstack/react-query'

import { installOnlineSignal } from './onlineSignal'
import { MAX_AGE_MS, PERSISTED_PREFIXES } from './persistPolicy'

export function createAppQueryClient(): QueryClient {
  installOnlineSignal()
  const client = new QueryClient()
  for (const prefix of PERSISTED_PREFIXES) client.setQueryDefaults(prefix, { gcTime: MAX_AGE_MS })
  return client
}
